// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2c6c209","453":"9e69c49f","455":"c91b2eb5","644":"25117898"}[chunkId] + ".chunk.js";
};